import IllustrationLocationError from 'assets/images/success/illustration_location_error.svg'
import { ReactNode } from 'react'

type Props = {
  renderFooter: () => ReactNode
}

const OutsideUS = ({ renderFooter }: Props) => {
  return (
    <div className="p-8 text-neutral-800">
      <img
        className="mb-10 block h-auto max-h-[300px] w-full max-w-[516px] object-contain"
        src={IllustrationLocationError}
        alt=""
      />
      <h2 className="typography-h5 mb-4 ">You are currently in a location TimelyCare does not serve</h2>
      <p className="typography-body">For support, please refer to your on-campus resources.</p>
      {renderFooter?.()}
    </div>
  )
}

export default OutsideUS
